import variables from '../../variables.module.scss';

const MuiStepLabel = {
  styleOverrides: {
    label: {
      color: variables.stepLabelColor,
      fontFamily: variables.fontRegular,
      fontSize: 14,
      textAlign: 'center',
      marginTop: '4px !important',
    },
  },
};

export default MuiStepLabel;
